<template>
  <div class="container mt-2 animate__animated animate__fadeIn animate__faster">
    <div class="row">
      <div class="col-12">
        <!-- Nav -->
        <button
          class="float-start btn btn-sm btn-primary"
          @click="goBack">
          <i class="fa fa-chevron-left"/>
          Back
        </button>
      </div>
      <div class="col-12">
        <div class="text-center position-relative">
          <h5 class="text-muted my-2">Select Customer</h5>
          <!-- Search -->
          <input
            class="form-control"
            placeholder="Search Customer by ID, Name or Address..."
            v-model="query"
            type="text">
          <i
            v-if="query.length"
            class="fa fa-times text-danger animate__animated animate__fadeInRight animate__faster"
            style="position: absolute; top: 43px; right: 10px; cursor: pointer;"
            @click="clearQuery"/>
        </div>
        <!-- Search Results -->
        <div>
          <table class="table table-striped">
            <tbody>
              <tr
                v-for="c in customers"
                :key="c.id"
                style="cursor: pointer;"
                class="animate__animated animate__fadeIn animate__faster"
                @click="setCustomer(c)">
                <td style="line-height: 18px;">
                  <div>
                    {{c.name}} ({{ c.id }})
                  </div>
                  <div class="text-muted">
                    <small>
                      <span>
                        {{ c.address1 }}
                      </span>
                      <span v-if="c.address2">
                        &nbsp;, {{ c.address2 }}
                      </span>
                      <span>
                        &nbsp;, {{ c.city }}
                      </span>
                      <span>
                        &nbsp;, {{ c.state_code }}
                      </span>
                      <span>
                        &nbsp;{{ c.zip_code }}
                      </span>
                    </small>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { customerSearch } from '../../js/displayTracking';

  // Initialize
  const emit = defineEmits(['goBack', 'setCustomer'])
  const store = useStore()
  
  // Data
  const query = ref('')
  
  // Methods
  const setCustomer = (customer)=>{
    store.dispatch('displayTrackingSetCustomer', customer)
  }

  const goBack = ()=>{
    store.dispatch('displayTrackingSetView', 'index')
  }

  const clearQuery = ()=>{
    query.value = ''
  }

  // Computed
  const customers = computed(()=>{
    if(query.value.length){
      const lowerQuery = query.value.toLocaleLowerCase()
      const list = store.getters.customerData.customer_list
      return customerSearch(list, lowerQuery)
    }
    return null
  })
</script>